/**
 * @file: ErpProviderId.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ErpProviderId {
  F6 = 'f6',
  Casstime = 'casstime',
  Heigu = 'heigu',
  Sihui = 'sihui',
  Gyyrkj = 'gyyrkj',
  ThreeSoft = 'three_soft',
  Scrj = 'scrj',
  T9090 = 't9090',
  Zhongtukj = 'zhongtukj',
}

export const ErpProviderIdValueSet = new Set([
  ErpProviderId.F6,
  ErpProviderId.Casstime,
  ErpProviderId.Heigu,
  ErpProviderId.Sihui,
  ErpProviderId.Gyyrkj,
  ErpProviderId.ThreeSoft,
  ErpProviderId.Scrj,
  ErpProviderId.T9090,
  ErpProviderId.Zhongtukj,
]);
